// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-map {
  min-width: 600px;
  min-height: 500px;
  margin: 50px;
  height: 100%;
  width: 100%;
}
.ol-expanded {
  left: 19px;
}
.ol-control {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  padding: 2px;
  z-index: 1000;
}
/*LAYER OR LAYER SWITCHER CONTROL*/
.layer-switcher {
  top: 54px; /* Prevent overlap with ZoomControl */
  left: 10px;
}
.layer-switcher ul{
  list-style-type: none; /* Remove bullets */
  margin: 0; /* Reset margin */
  padding: 0; /* Reset padding */
}

.layer-switcher ul li {
  padding: 5px 10px; /* Adjust spacing for clarity */
}
.ol-layerswitcher {
  top: 54px; /* Prevent overlap with ZoomControl */
  left: 10px;
}
.ol-layerswitcher ul {
    list-style-type: none; /* Remove bullets */
    margin: 0; /* Reset margin */
    padding: 0; /* Reset padding */
  }
  
  /* Optionally style list items for better appearance */
  .ol-layerswitcher ul li {
    padding: 5px 10px; /* Adjust spacing for clarity */
  }
.ol-scale-bar {
  bottom: 40px; /* Anchored to the bottom of the map container */
  z-index: 1000;
}
.ol-zoom {
  top: 10px;
  left: 10px;
}

.ol-attribution {
  bottom: 10px; /* Anchored to the bottom */
  right: 10px; /* On the right side */
}

.ol-full-screen {
  top: 0.5em;
  right: 0.5em;
}
.north-arrow {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
}

.arrow-up, .arrow-down {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
}

.arrow-up {
  border-bottom: 15px solid black;
  top: 0;
  left: 5px;
}

.arrow-down {
  border-top: 15px solid black;
  bottom: 0;
  left: 5px;
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/pages/Views/LandInfraDevelopment/GISView/MapRelated/Map/Map.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA,kCAAkC;AAClC;EACE,SAAS,EAAE,qCAAqC;EAChD,UAAU;AACZ;AACA;EACE,qBAAqB,EAAE,mBAAmB;EAC1C,SAAS,EAAE,iBAAiB;EAC5B,UAAU,EAAE,kBAAkB;AAChC;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;AACpD;AACA;EACE,SAAS,EAAE,qCAAqC;EAChD,UAAU;AACZ;AACA;IACI,qBAAqB,EAAE,mBAAmB;IAC1C,SAAS,EAAE,iBAAiB;IAC5B,UAAU,EAAE,kBAAkB;EAChC;;EAEA,sDAAsD;EACtD;IACE,iBAAiB,EAAE,+BAA+B;EACpD;AACF;EACE,YAAY,EAAE,gDAAgD;EAC9D,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY,EAAE,2BAA2B;EACzC,WAAW,EAAE,sBAAsB;AACrC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,MAAM;EACN,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,SAAS;EACT,yBAAyB;AAC3B","sourcesContent":[".ol-map {\r\n  min-width: 600px;\r\n  min-height: 500px;\r\n  margin: 50px;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.ol-expanded {\r\n  left: 19px;\r\n}\r\n.ol-control {\r\n  position: absolute;\r\n  background-color: rgba(255, 255, 255, 0.4);\r\n  border-radius: 4px;\r\n  padding: 2px;\r\n  z-index: 1000;\r\n}\r\n/*LAYER OR LAYER SWITCHER CONTROL*/\r\n.layer-switcher {\r\n  top: 54px; /* Prevent overlap with ZoomControl */\r\n  left: 10px;\r\n}\r\n.layer-switcher ul{\r\n  list-style-type: none; /* Remove bullets */\r\n  margin: 0; /* Reset margin */\r\n  padding: 0; /* Reset padding */\r\n}\r\n\r\n.layer-switcher ul li {\r\n  padding: 5px 10px; /* Adjust spacing for clarity */\r\n}\r\n.ol-layerswitcher {\r\n  top: 54px; /* Prevent overlap with ZoomControl */\r\n  left: 10px;\r\n}\r\n.ol-layerswitcher ul {\r\n    list-style-type: none; /* Remove bullets */\r\n    margin: 0; /* Reset margin */\r\n    padding: 0; /* Reset padding */\r\n  }\r\n  \r\n  /* Optionally style list items for better appearance */\r\n  .ol-layerswitcher ul li {\r\n    padding: 5px 10px; /* Adjust spacing for clarity */\r\n  }\r\n.ol-scale-bar {\r\n  bottom: 40px; /* Anchored to the bottom of the map container */\r\n  z-index: 1000;\r\n}\r\n.ol-zoom {\r\n  top: 10px;\r\n  left: 10px;\r\n}\r\n\r\n.ol-attribution {\r\n  bottom: 10px; /* Anchored to the bottom */\r\n  right: 10px; /* On the right side */\r\n}\r\n\r\n.ol-full-screen {\r\n  top: 0.5em;\r\n  right: 0.5em;\r\n}\r\n.north-arrow {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.arrow-up, .arrow-down {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 15px solid transparent;\r\n  border-right: 15px solid transparent;\r\n}\r\n\r\n.arrow-up {\r\n  border-bottom: 15px solid black;\r\n  top: 0;\r\n  left: 5px;\r\n}\r\n\r\n.arrow-down {\r\n  border-top: 15px solid black;\r\n  bottom: 0;\r\n  left: 5px;\r\n  transform: rotate(180deg);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
